import { useI18n } from "../i18n/useI18n";
import { useTheme } from "../theme/context";

export function ThemeToggle() {
  const { theme, setTheme } = useTheme();
  const { t } = useI18n();

  return (
    <div className="seg" role="group" aria-label={t("theme.aria")}>
      {(["light", "dark"] as const).map((code) => (
        <button
          key={code}
          type="button"
          className={"seg__btn" + (theme === code ? " seg__btn--on" : "")}
          onClick={() => setTheme(code)}
          aria-pressed={theme === code}
        >
          {code === "light" ? t("theme.light") : t("theme.dark")}
        </button>
      ))}
    </div>
  );
}
